/*
 * @Author: Gang Jiang
 * @Date: 2026-03-05 10:53:57
 * @LastEditors: Gang Jiang
 * @LastEditTime: 2026-06-02 14:18:49
 */

import client from './client';


export default {
  getList: (data) => {
    return client
      .get(
        `/finance/${data.type == 'dmReceived' ? 'dm-received' : 'kol'}/payments?` +
        Object.keys(data || {})
          .filter((key) => key !== 'type')
          .map((key) => `${key}=${data[key]}`)
          .join('&')
      )
      .then((res) => res.data);
  },
  addNote: (data) => {
    return client.post(`/finance/${data.type == 'dmReceived' ? 'dm-received' : 'kol'}/payment/${data.paymentId}/note`, { note: data.note }).then(res => res.data);
  },
  exchangeRate: (data) => {
    return client.post(`finance/dm-received/payment/${data.paymentId}/confirm-preview`, { financeConfirmReceivedAmountUsd: data.financeConfirmReceivedAmountUsd }).then(res => res.data);
  },
  saveExchangeRate: (data) => {
    return client.post(`finance/dm-received/payment/${data.paymentId}/confirm`, { financeConfirmReceivedAmountUsd: data.financeConfirmReceivedAmountUsd, currencyExchangeRate: data.exchangeRate }).then(res => res.data);
  },
  // DmReceived详情页统计数据,接口地址：https://app.apifox.com/link/project/7888978/apis/api-440620671
  getDmReceivedDetailStats: (paymentid) => {
    return client.get(`finance/dm-received/payment/${paymentid}/details-summary`).then(res => res.data);
  },
  // DmReceived参考金额（Reference Amount USD）,接口地址：https://app.apifox.com/link/project/7888978/apis/api-440620672
  getDmReceivedConfirmReferenceAmount: (paymentid) => {
    return client.get(`finance/dm-received/payment/${paymentid}/reference-amount`).then(res => res.data);
  },
  getCommissionList: (data) => {
    return client.get(`finance/${data.type == 'dmReceived' ? 'dm-received' : 'kol'}/payment/${data.paymentId}/details?${Object.keys(data || {})
      .filter((key) => key !== 'type' && key !== 'paymentId' && data[key] !== '')
      .map((key) => `${key}=${data[key]}`)
      .join('&')}`).then(res => res.data);
  },
  getPaymentDetail: (data) => {
    return client.get(`finance/${data.type == 'dmReceived' ? 'dm-received' : 'kol'}/payment/${data.paymentId}`).then(res => res.data);
  },
  // 确认KOL账单
  confirmPayment: (paymentId) => {
    return client.post(`finance/kol/payment/${paymentId}/confirm`).then(res => res.data);
  },
  // 批量支付KOL账单
  payPayments: (paymentIds) => {
    return client.post('finance/kol/payments/pay', { paymentIds }).then(res => res.data);
  },
  // 调整KOL账单
  adjustmentAmountUsdForKol: (data) => {
    return client.post(`finance/kol/payment/${data.paymentId}/adjust`, { adjustmentAmountUsdForKol: data.amount, adjustmentReason: data.reason }).then(res => res.data);
  },
  // Pending Payment详情页获取所有Payment ID
  getPaymentIds: (id) => {
    return client.get(`finance/kol/payment/${id}/dm-received-payment/ids`).then(res => res.data);
  }
}
